var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeritcalTabsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 96,
    viewBox: "0 0 141 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.17065,
    width: 138.938,
    height: 93.6588,
    rx: 4.30964,
    stroke: "#F8F6F4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34093 10.2477C9.47118 10.2477 10.3874 9.3314 10.3874 8.20116C10.3874 7.07091 9.47118 6.15466 8.34093 6.15466C7.21068 6.15466 6.29443 7.07091 6.29443 8.20116C6.29443 9.3314 7.21068 10.2477 8.34093 10.2477Z",
    stroke: "#F8F6F4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8243 10.2477C16.9546 10.2477 17.8708 9.3314 17.8708 8.20116C17.8708 7.07091 16.9546 6.15466 15.8243 6.15466C14.6941 6.15466 13.7778 7.07091 13.7778 8.20116C13.7778 9.3314 14.6941 10.2477 15.8243 10.2477Z",
    stroke: "#F8F6F4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3077 10.2477C24.438 10.2477 25.3542 9.3314 25.3542 8.20116C25.3542 7.07091 24.438 6.15466 23.3077 6.15466C22.1775 6.15466 21.2612 7.07091 21.2612 8.20116C21.2612 9.3314 22.1775 10.2477 23.3077 10.2477Z",
    stroke: "#F8F6F4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.1746H139.938",
    stroke: "#F8F6F4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1782 15.1746L40.1782 94.5899",
    stroke: "#F8F6F4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.2356,
    y: 20.469,
    width: 30.7073,
    height: 7.25982,
    rx: 0.861928,
    fill: "#CCEDFE",
    stroke: "#F8F6F4",
    strokeWidth: 0.861928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.2356,
    y: 57.4091,
    width: 30.7073,
    height: 7.25982,
    rx: 0.861928,
    fill: "#CCEDFE",
    stroke: "#F8F6F4",
    strokeWidth: 0.861928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.2356,
    y: 32.7823,
    width: 30.7073,
    height: 7.25982,
    rx: 0.861928,
    fill: "#CCEDFE",
    stroke: "#F8F6F4",
    strokeWidth: 0.861928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.2356,
    y: 69.7224,
    width: 30.7073,
    height: 7.25981,
    rx: 0.861928,
    fill: "#CCEDFE",
    stroke: "#F8F6F4",
    strokeWidth: 0.861928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.2356,
    y: 45.0957,
    width: 30.7073,
    height: 7.25981,
    rx: 0.861928,
    fill: "#CCEDFE",
    stroke: "#F8F6F4",
    strokeWidth: 0.861928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.2356,
    y: 82.0359,
    width: 30.7073,
    height: 7.25981,
    rx: 0.861928,
    fill: "#CCEDFE",
    stroke: "#F8F6F4",
    strokeWidth: 0.861928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeritcalTabsIcon);
export default __webpack_public_path__ + "static/media/veritcal_tabs_icon.6271512151f9dc102a6f3f3400e7563a.svg";
export { ForwardRef as ReactComponent };